export const getBackgroundColorClass = (type) => `bg-${type}`;
export const getColorClass = (type) => `c-${type}`;
